<template>
	<div>
		<ViewAlbumEmbedCarousel
			v-if="carousel"
			:album="album"
		/>

		<ViewAlbumEmbed
			v-else
			:album="album"
		/>
	</div>
</template>

<script>
import { httpClient } from '@shared/js/api/httpClient';
import ViewAlbumEmbedCarousel from './ViewAlbumEmbedCarousel.vue';
import ViewAlbumEmbed from './ViewAlbumEmbed.vue';

export default {
	name:       'ViewDynamicAlbum',
	components: { ViewAlbumEmbedCarousel, ViewAlbumEmbed },
	props:      {
		carousel: {
			type:    Boolean,
			default: true,
		},
		count: {
			type:    Number,
			default: 10,
		},
		filters: {
			type:    Object,
			default: () => {},
		},
		sortOrder: {
			type:    [Object, Array],
			default: () => {},
		},
	},
	data: function() {
		return {
			album: {
				events:    [],
				isLoading: true,
			},
		};
	},
	mounted: function() {
		this.loadEvents();
	},
	methods: {
		async loadEvents() {
			try {
				const opts = { page: 1, perPage: this.count };

				if (this.filters) {
					opts.filters = JSON.stringify(this.filters);
				}
				if (this.sortOrder) {
					opts.sortOrder = JSON.stringify(this.sortOrder);
				}
				const response = await httpClient.getDynamicAlbumEvents(opts);
				if (response.status === 200) {
					this.album = {
						events: response.data?.data || [],
					};
				}
			} catch (error) {
				// shows empty album
				this.album = {
					events: [],
				};
			} finally {
				this.album.isLoading = false;
			}
		},
	},
};
</script>

<style>

</style>
